import React from "react";

/**
 * Safely render insight text that highlights percentages and HH:MM ranges
 * without injecting raw HTML strings (safe from XSS).
 * Returns an array of React nodes.
 */
export function highlightNumbers(text, className = "text-[#1e40af] font-semibold") {
  if (!text) return null;
  // Combined regex — split at either a percentage or an HH:MM (optionally range) token
  const parts = String(text).split(
    /(\d+(?:\.\d+)?%|\d{2}:\d{2}(?:\s*[–-]\s*\d{2}:\d{2})?)/g
  );
  return parts.map((p, i) => {
    if (!p) return null;
    const isMatch =
      /^\d+(?:\.\d+)?%$/.test(p) ||
      /^\d{2}:\d{2}(?:\s*[–-]\s*\d{2}:\d{2})?$/.test(p);
    return isMatch ? (
      <strong key={`hl-${i}`} className={className}>{p}</strong>
    ) : (
      <React.Fragment key={`t-${i}`}>{p}</React.Fragment>
    );
  });
}
